import {
  DoubleMaterialityStakeholderESRSArea,
  DoubleMaterialityStakeholderImpactArea,
} from "@green0meter/api-client";

export const labelMap: Record<DoubleMaterialityStakeholderImpactArea, string> = {
  [DoubleMaterialityStakeholderImpactArea.Risk]: "Risks",
  [DoubleMaterialityStakeholderImpactArea.Opportunity]: "Opportunities",
  [DoubleMaterialityStakeholderImpactArea.Impact]: "Impact",
} as const;

export const colorMap: Record<
  DoubleMaterialityStakeholderImpactArea,
  "success" | "default" | "warning"
> = {
  [DoubleMaterialityStakeholderImpactArea.Risk]: "warning",
  [DoubleMaterialityStakeholderImpactArea.Opportunity]: "success",
  [DoubleMaterialityStakeholderImpactArea.Impact]: "default",
} as const;

export const ESRS_TYPES: Record<DoubleMaterialityStakeholderESRSArea, string> = {
  [DoubleMaterialityStakeholderESRSArea.ClimateChange]: "E1",
  [DoubleMaterialityStakeholderESRSArea.Pollution]: "E2",
  [DoubleMaterialityStakeholderESRSArea.WaterAndMarineSources]: "E3",
  [DoubleMaterialityStakeholderESRSArea.BiodiversityAndEcosystems]: "E4",
  [DoubleMaterialityStakeholderESRSArea.CircularEconomy]: "E5",
  [DoubleMaterialityStakeholderESRSArea.OwnWorkforce]: "S1",
  [DoubleMaterialityStakeholderESRSArea.WorkersInValueChain]: "S2",
  [DoubleMaterialityStakeholderESRSArea.AffectedCommunities]: "S3",
  [DoubleMaterialityStakeholderESRSArea.ConsumersAndEndUsers]: "S4",
  [DoubleMaterialityStakeholderESRSArea.BusinessConduct]: "G1",
  [DoubleMaterialityStakeholderESRSArea.Other]: "OTHER",
} as const;
